export const CHANGE_TYPE = {
  ADDED: { label: 'Added', className: 'added' },
  REMOVED: { label: 'Removed', className: 'removed' },
  EDITED: { label: 'Edited', className: 'edited' },
};

export const SECTIONS = {
  NOTES: 'NOTES',
  INTERNAL_NOTES: 'INTERNAL_NOTES',
  WEATHER_NOTES: 'WEATHER_NOTES',
  DATE: 'DATE',
  WEATHER: 'WEATHER',
  RALLY_POINT: 'RALLY_POINT',
  PROJECT_LOCATION: 'PROJECT_LOCATION',
  COMMENTS: 'COMMENTS',
  START_TIME: 'START_TIME',
  ON_JOB_TIME: 'ON_JOB_TIME',
  TRAVEL_TIME_TO: 'TRAVEL_TIME_TO',
  TRAVEL_TIME_FROM: 'TRAVEL_TIME_FROM',
  CREW: 'CREW',
  EQUIPMENT: 'EQUIPMENT',
};
